export const toDisplayAmount = (value: number) =>
  value.toLocaleString('en', { useGrouping: true, minimumFractionDigits: 2, maximumFractionDigits: 2 })

export const toDisplayAmountNoDecimal = (value: number) => toDisplayAmount(value).replace(/\.00$/, '')

export const SCROLLBAR_HIDDEN_STYLE = {
  '&::-webkit-scrollbar': {
    display: 'none',
  },
  msOverflowStyle: 'none' /* IE and Edge */,
  scrollbarWidth: 'none' /* Firefox */,
}

export const sum = (value: number[]): number => value.reduce((a, b) => a + b, 0)

export const formatAmount = (amount: number | number[]): string => {
  if (Array.isArray(amount)) {
    return toDisplayAmountNoDecimal(sum(amount))
  }

  return toDisplayAmountNoDecimal(amount)
}

export const roundToTwoDecimals = (value: number) => Math.floor((value + Number.EPSILON) * 100) / 100
